/**
 * Base URL for the authenticated Loristry app. Consumers read this
 * constant instead of accepting an `appUrl` prop — avoids prop-drilling
 * through Nav, Hero, Pricing, and Footer.
 */
export const APP_URL = process.env.NEXT_PUBLIC_APP_URL || 'https://app.loristry.com';
